export enum Products {
    s1 = "S1",
    m10 = "M10",
    x20 = "X20"
}
